import * as React from 'react';

import { SegmentLabel } from '@acceligentllc/storybook';

import { previewSectionClass, previewSectionClassColumn6, previewSectionClassRow } from '../../helpers';

type Props = {
	summaryOfWork: Nullable<string>;
};

const SummaryOfWorkSection: React.FC<Props> = (props) => {
	const { summaryOfWork } = props;
	return (
		<div className={previewSectionClass}>
			<SegmentLabel
				label="Summary of Work"
				tooltip="Job notes shown on the Work Order, visible to the worker on the WO Confirmation modal."
			/>
			<div className={previewSectionClassRow}>
				<div className={previewSectionClassColumn6}>
					<b>{summaryOfWork ?? '-'}</b>
				</div>
			</div>
		</div>
	);
};

export default React.memo(SummaryOfWorkSection);
